module.exports = "/packs/step2-d619530e769ffc3fbc96724ca1137ae8.png";